
const api = "http://localhost:8000"

export {api}
